import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Tips from '../views/tips.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/About',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/distribution',
    name: 'distribution',
    component: () => import('../views/distribution.vue')
  },
  {
    path: '/tips',
    name: 'Tips',
    component: Tips
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
